import requests from "./httpService";



const BillPaymentReportServices = {
  billpaymentreportRequestList: async (body) => {
    return requests.post(`/billPayment/report`, body);
  },
  billpaymentreportRequestExport: async ({ from, to, type, is_vendor, id }) => {
    // Backend treats the literal string '' (not an empty path segment, which
    // isn't possible in a URL) as "no date filter" — see exportExcel's check.
    const fromSeg = from || "''";
    const toSeg = to || "''";
    return requests.get(
      `/billPayment/exportExcel/${fromSeg}/${toSeg}/${type}/${is_vendor}/${id}`
    );
  },
};

export default BillPaymentReportServices;
